import { render, staticRenderFns } from "./TeamTargetAndRewardValues.vue?vue&type=template&id=0ea710fc&scoped=true&"
import script from "./TeamTargetAndRewardValues.vue?vue&type=script&lang=js&"
export * from "./TeamTargetAndRewardValues.vue?vue&type=script&lang=js&"
import style0 from "./TeamTargetAndRewardValues.vue?vue&type=style&index=0&id=0ea710fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea710fc",
  null
  
)

export default component.exports